
import { Config, CloudObject, WorkflowObjectState } from 'olympe';
import { getLogger } from '@olympeio/core';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import FormControl from '@mui/material/FormControl';
import { NumericFormat } from "react-number-format";
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import React, { useRef, useEffect, useState } from 'react';
import { updateProperty } from '../../shared/datagrid/DataGridRenderers.jsx';
import MenuItem from '@mui/material/MenuItem';
import { contriesList } from '../../section_sf/Utils.js'
import { getIcon } from '../../shared/utils/_icons.jsx';
import { YesNoDropdown } from '../YesNoDropdown.jsx';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import { AlternativeVendorDropdown } from '../../section_bcp/renderers/AlternativeVendorDropdown.jsx';
import BCP from '../../../common/section_bcp/DM_BCP';
import { getApplicationContext } from '../../../common/utils/Context.js';
import { QA_ROLES } from '../../section_sf/Utils';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide'
import { padLeftWithZerosFinalDigits } from '../mass_import/utils.js';
import { getCurrentWorkflow, BCP_WORKFLOW_STATES } from '../../../common/section_bcp/BcpWorkflowAuthorizations';
import Snackbar from '@mui/material/Snackbar'
import { HighLowDropdown } from './HighLowDropdown.jsx';
import { Tooltip } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" {...props} />;
});

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabPanel"
            sx={{ overflowY: 'scroll' }}
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{
                borderRadius: 1,
            }}>{children}</Box>}
        </div>
    );
}

const GetReactElement = (props) => {
    const logger = getLogger('MassUpdateDialogComponent: GetReactElement')
    const containerRef = useRef(null);
    let { columnName, data, isUserDDDisabled, state, context } = props;
    logger.info("::::columnName, uniqueWorkflowElements ,isUserDDDisabled:::::", columnName, isUserDDDisabled);
    let formattedData = data && data?.split(/[:;]/);
    let userName = formattedData?.[0];
    let email = formattedData?.[1];
    let dropdownContext = {};


    useEffect(() => {
        async function renderDropDown() {
            const userDropdown = context.get('userDropdown');
            const domElement = document.createElement('div');
            if (containerRef.current) {
                containerRef.current.appendChild(domElement);
            }
            dropdownContext = context
                ?.runner(userDropdown)
                ?.setParentElement(domElement);
            dropdownContext?.set('disabled', isUserDDDisabled);
            try {
                if (userName && email) {
                    let userObject = { mail: email, displayName: userName };
                    dropdownContext.set('inputUser', userObject);
                }
            } catch (error) {
                logger.error(
                    `Failed to get slected user: `,
                    error
                );
            }
            // this is triggered by dispatch events from
            dropdownContext?.observe('user').subscribe((userObject) => {
                context.set('buttonDisableStatus', false);
                let objectUser = userObject?.displayName
                    ?.concat(';')
                    ?.concat(userObject?.mail);
                if (columnName === QA_ROLES.CTAG_AG) {
                    logger.info("::::CTAG_AG::::", objectUser)
                    context.set('CTAG', userObject);
                } else if (columnName === QA_ROLES.SQA) {
                    logger.info("::::SQA::::", objectUser)
                    context.set('SQA', userObject);
                } else if (columnName === QA_ROLES.QA_IN_FACTORY) {
                    logger.info("::::QA_IN_FACTORY::::", objectUser)
                    context.set('QAInFactory', userObject);
                } else if (columnName === QA_ROLES.BP) {
                    logger.info("::::BP::::", objectUser)
                    context.set('businessPartner', userObject);
                } else if (columnName === QA_ROLES.PM) {
                    logger.info("::::PM::::", objectUser)
                    context.set("procurementManager", userObject)
                } else if (columnName === QA_ROLES.PS) {
                    logger.info("::::PS::::", objectUser)
                    context.set("PS", userObject)
                } else if (columnName === QA_ROLES.REQUESTOR) {
                    logger.info("::::REQUESTOR::::", objectUser)
                    context.set("Requestor", userObject)
                }
            });
            return () => {
                containerRef.current.removeChild(domElement);
                dropdownContext.destroy();
            };
        }
        renderDropDown();
    }, [data, state]);
    return <div ref={containerRef} />;
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator
        />
    );
}

export const MassUpdateDialogComponent = (props) => {
    const messageRef = React.createRef();
    let uniqueWorkflowElements;
    const logger = getLogger('Mass Update Dialog Component');
    const { context } = props;
    logger.info(" Get value of Olympe context", context)
    const applicationContext = getApplicationContext(context);
    let selectdBCPs = applicationContext.get("selectedBCPs")
    logger.info(":::: selectd BCPs ::::", selectdBCPs)
    let buttonStatus = context.get("buttonDisableStatus")
    logger.info("::: button Status new:::", buttonStatus)

    useEffect(() => {
        GetReactElement
    }, [GetReactElement])

    useEffect(() => {
        getButtonStatuses
    }, [getButtonStatuses])


    useEffect(() => {
        getButtonStatus
    }, [getButtonStatus])


    useEffect(() => {
        getSelectedBCP
    }, [getSelectedBCP])

    const handleNumberChange = event => {
        logger.info("Input saving value", event.target.value)
        setState(({ ...state, inputSavingsValue: parseFloat(event.target.value) }));
    };
    const [state, setState] = useState({
        value: 0,
        bcpRequest: getSelectedBCP(),
        country: "",
        remarks: "",
        oscarId: "",
        maguireVal: "",
        savingsIndicator: "",
        anyGHGReduction: "",
        inputSavingsValue: "",
        alternateVendor: "",
        priority: "",
        mvLinkedVendor: "",
        vendorName: "",
        showSuccessMessage: false,
        targetBCP: "",
        vendorAddress: "",
        vendorCity: "",
        vendorContactNo: "",
        vendorEmail: "",
        requestr: context.get('Requestor'),
        bp: context.get('businessPartner'),
        pm: context.get('procurementManager'),
        ctag: context.get('CTAG'),
        sqa: context.get('SQA'),
        qaInFactory: context.get('QAInFactory'),
        ps: context.get('PS'),
        latestWorkflowsArray: [],
        buttonDisabledStatus: true
    });
    const [emailError, setEmailError] = useState(false);
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseBar = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpenSnackBar(false)
    };

    const handleDataSave = async () => {
        logger.info(" saving State variable values :", state, context.get('businessPartner'),
            context.get('Requestor'), context.get('procurementManager'), context.get('CTAG'), context.get('procurementManager'), context.get('SQA'),
            context.get('QAInFactory'), context.get('QAInFactory'))
        let BP_Role = [BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP];
        let REJECTION_Role = [BCP_WORKFLOW_STATES.REJECTED];
        let BP_PM_Role = [BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP, BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM];
        let BP_PM_CTAG_Role = [BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP, BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE]
        let BP_PM_CTAG_SQ1_Role = [BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP, BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE,
        BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1]
        let BP_PM_CTAG_SQ1_SQ2_Role = [BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP, BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE,
        BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2]

        if (Object.entries(selectdBCPs).length > 0) {
            for (const [key, value] of Object.entries(selectdBCPs)) {
                logger.info("BCP data:", key, value[0]);
                let bcpRequest = CloudObject?.get(value?.tag) || value

                let alternativeVendor = bcpRequest.get(BCP.alternativeVendorCodeProp);

                const currentWorkflowState = await getCurrentWorkflow(value, context)?.get(WorkflowObjectState.stateProp);
                logger.info("::::::::: currentWorkflowState, alternativeVendor ::::::::::::", currentWorkflowState, alternativeVendor)
                if (state?.savingsIndicator?.length > 0) {
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.costSavingsProp,
                        state.savingsIndicator
                    );
                    if (state?.savingsIndicator === 'no') {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.inputSavingEstimatesProp,
                            null
                        );
                    } else {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.inputSavingEstimatesProp,
                            state.inputSavingsValue
                        );
                    }
                }

                if (state?.maguireVal?.length > 0) {
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.maguireEligibilityProp,
                        state.maguireVal
                    );
                }

                if (state?.priority?.length > 0) {
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.priorityProp,
                        state.priority
                    );
                }

                if (state?.targetBCP?.length > 0) {
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.targetBCPProp,
                        state.targetBCP
                    );
                }

                if (state?.anyGHGReduction?.length > 0) {
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.ghgReductionProp,
                        state.anyGHGReduction
                    );
                }
                console.log("::::state.oscarId chayan::::::::", state.oscarId, state?.oscarId.length)
                if (state?.oscarId?.length > 0) {
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.oscarIdProp,
                        state.oscarId
                    );
                }
                if (state?.remarks?.length > 0) {
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.remarkProp,
                        state.remarks
                    );
                }

                if (state?.alternateVendor?.length > 0) {
                    const vendorVal = ["No vendor selected", null].includes(state.alternateVendor) ? null : state.alternateVendor.slice(0, state.alternateVendor.indexOf('-'));
                    logger.info(":::::::::::: vendorVal ::::", vendorVal)
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.alternativeVendorCodeProp,
                        padLeftWithZerosFinalDigits(vendorVal, 10)
                    );
                }
                if (state?.mvLinkedVendor?.length > 0) {
                    const mvLinkedVendor = ["No vendor selected", null].includes(state.mvLinkedVendor) ? null : state.mvLinkedVendor.slice(0, state.mvLinkedVendor.indexOf('-'));
                    logger.info(":::::::::::: mvLinkedVendor ::::", mvLinkedVendor)
                    updateProperty(
                        context,
                        bcpRequest,
                        BCP.mainVendorLinkedAltVendorProp,
                        padLeftWithZerosFinalDigits(mvLinkedVendor, 10)
                    );
                }

                if (!(alternativeVendor?.length > 0 || state?.alternateVendor?.length > 0)) {

                    if (state?.vendorAddress?.length > 0) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.vdetAddressProp,
                            state.vendorAddress
                        );
                    }

                    if (state?.vendorName?.length > 0) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.vdetNameProp,
                            state.vendorName
                        );
                    }

                    if (state?.vendorCity?.length > 0) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.vdetCityProp,
                            state.vendorCity
                        );
                    }

                    if (state?.vendorContactNo?.length > 0) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.vdetContactNumberProp,
                            state.vendorContactNo
                        );
                    }

                    if (state?.vendorEmail?.length > 0) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.vdetEmailProp,
                            state.vendorEmail
                        );
                    }

                    if (state?.country?.length > 0) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.vdetCountryProp,
                            state.country
                        );
                    }
                }

                let businessPartner = context.get('businessPartner')?.displayName
                    ?.concat(';')
                    ?.concat(context.get('businessPartner')?.mail)

                let procurementManager = context.get('procurementManager')?.displayName
                    ?.concat(';')
                    ?.concat(context.get('procurementManager')?.mail);

                let CTAG = context.get('CTAG')?.displayName
                    ?.concat(';')
                    ?.concat(context.get('CTAG')?.mail);

                let SQA = context.get('SQA')?.displayName
                    ?.concat(';')
                    ?.concat(context.get('SQA')?.mail);

                let QAInFactory = context.get('QAInFactory')?.displayName
                    ?.concat(';')
                    ?.concat(context.get('QAInFactory')?.mail)

                let PS = context.get('PS')?.displayName
                    ?.concat(';')
                    ?.concat(context.get('PS')?.mail)

                let Requestor = context.get('Requestor')?.displayName
                    ?.concat(';')
                    ?.concat(context.get('Requestor')?.mail)

                if (businessPartner?.length > 0) {
                    if (BP_Role.includes(currentWorkflowState)) {
                        updateProperty(
                            context,
                            bcpRequest, BCP.businessPartnerProp, businessPartner)
                    }
                }
                if (procurementManager?.length > 0) {
                    if (BP_PM_Role.includes(currentWorkflowState) && !REJECTION_Role.includes(currentWorkflowState)) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.procurementManagerProp,
                            procurementManager)
                    }
                }
                if (CTAG?.length > 0) {
                    if (BP_PM_CTAG_Role.includes(currentWorkflowState) && !REJECTION_Role.includes(currentWorkflowState)) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.technicalApplicationGroupProp,
                            CTAG)
                    }
                }
                if (SQA?.length > 0) {
                    if (BP_PM_CTAG_SQ1_SQ2_Role.includes(currentWorkflowState) && !REJECTION_Role.includes(currentWorkflowState)) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.qualityAssuranceProp,
                            SQA
                        );
                    }
                }
                if (QAInFactory?.length > 0) {
                    if (BP_PM_CTAG_SQ1_Role.includes(currentWorkflowState) && !REJECTION_Role.includes(currentWorkflowState)) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.qaInFactoryProp,
                            QAInFactory
                        );
                    }
                }
                if (PS?.length > 0) {
                    if (BP_PM_CTAG_SQ1_SQ2_Role.includes(currentWorkflowState) && !REJECTION_Role.includes(currentWorkflowState)) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.procurementSpecialistProp,
                            PS
                        );
                    }
                }
                if (Requestor?.length > 0) {
                    if (!REJECTION_Role.includes(currentWorkflowState)) {
                        updateProperty(
                            context,
                            bcpRequest,
                            BCP.requestorProp,
                            Requestor
                        );
                    }
                }

                handleClose();
                handleScrollUp();
                setState({ ...state, showSuccessMessage: true });
                applicationContext.set(
                    'selectedBCPs',
                    []
                );
                setTimeout(function () {
                    props.context.trigger('on Close');
                }, 2000);
            }
        }
    }
    // Get the status of the Button based on if users fills in the data or not. In case no data is input we would show message of No data in a snackbar
    const getButtonStatus = () => {
        let buttonDisableStatus = !state.oscarId && !state.savingsIndicator && !state.priority && !state.targetBCP
            && !state.inputSavingsValue &&
            !state.anyGHGReduction && !(state.alternateVendor || state.mvLinkedVendor ||
                state.country || state.vendorContactNo || state.vendorAddress ||
                state.vendorCity || state.vendorName || state.vendorEmail) && !state.remarks
            && !(context.get('Requestor')?.displayName?.length > 0
                || context.get('businessPartner')?.displayName?.length > 0
                || context.get('procurementManager')?.displayName?.length > 0
                || context.get('CTAG')?.displayName?.length > 0
                || context.get('SQA')?.displayName?.length > 0
                || context.get('QAInFactory')?.displayName?.length > 0
                || context.get('PS')?.displayName?.length > 0)
        return buttonDisableStatus;
    }
    const [disableVendor, setDisableVendor] = useState(false)

    //disable vendor details if alt vendor is present
    const checkAltVendor = (val) => {
        setDisableVendor(val !== null && val !== "No vendor selected" && val !== "")
    }
    function getSelectedBCP() {
        let bcpRequest;
        logger.info("<< Inside useEffect:::", selectdBCPs?.length)
        if (selectdBCPs?.length > 0) {
            for (const [key, value] of Object?.entries(selectdBCPs)) {
                logger.info("::BCP data::key, value, selectdBCPs", key, value, selectdBCPs);
                bcpRequest = CloudObject.get(value.tag) || value
            }
        } else {
            bcpRequest = null;
        }
        logger.info(":::::selected bcpRequest::::", bcpRequest);
        return bcpRequest;
    }
    const getUniqueWorkflowStatuses = async (element) => {
        // logger.info("<< Inside getUniqueWorkflowStatuses:::", element)
        let bcpCurrentStatusArray = [];
        if (selectdBCPs?.length > 0) {
            for (const [key, value] of Object?.entries(selectdBCPs)) {
                const currentWorkflowState = await getCurrentWorkflow(value, context)?.get(WorkflowObjectState.stateProp);
                bcpCurrentStatusArray.push(currentWorkflowState);
                bcpCurrentStatusArray = bcpCurrentStatusArray?.filter(function (element) {
                    return element !== undefined;
                });
                uniqueWorkflowElements = new Set(bcpCurrentStatusArray)
                //logger.info("Unique set of latest workflow objects ::", uniqueWorkflowElements)
            }
        } else {
            uniqueWorkflowElements = new Set();
        }
        let qualityRoles = [BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION,
        BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE];

        switch (element?.column) {
            case "Requestor":
                return Array.from(uniqueWorkflowElements).some(r => qualityRoles.includes(r))
            case "Business Partner":
                return Array.from(uniqueWorkflowElements).some(r => qualityRoles.includes(r))
            case "Procurement Manager":
                return Array.from(uniqueWorkflowElements).some(r => qualityRoles.includes(r))
            case "CTAG/AG":
                return Array.from(uniqueWorkflowElements).some(r => qualityRoles.includes(r))
            case "QA in Factory":
                return Array.from(uniqueWorkflowElements).some(r => qualityRoles.includes(r))
            case "SQA at host market":
                return Array.from(uniqueWorkflowElements).some(r => qualityRoles.includes(r))
            case "Procurement Specialist":
                return false
            default:
                break;
        }
    }
    const getButtonStatuses = () => {
        if (null === context.get('buttonDisableStatus')) return true
        else return context.get('buttonDisableStatus')
    }

    const [openSnackBar, setOpenSnackBar] = useState(false);

    // SQA link list - to refer the document
    const sqaLink = Config.getParameter('sqaListLink');
    const dropdownFields = [
        {
            label: 'Requestor',
            labelText: 'Requestor can be updated by any stakeholder in the workflow or admins accordingly',
            column: 'Requestor',
            value: context.get('Requestor')
        },
        {
            label: 'Business Partner',
            labelText: 'BP is responsible to align Business Priority & resource allocation with Business unit & other functions. This is a critical step for the workflow',
            column: 'Business Partner',
            value: context.get('businessPartner')
        },
        {
            label: 'Procurement Manager',
            labelText: 'PM is responsible to finallize the alternative vendor to be developed as a BCP',
            column: 'Procurement Manager',
            value: context.get('procurementManager')
        },
        {
            label: 'Application Group',
            labelText: 'Application Group is responsible to provide a due date for the completion of local acceptance activities',
            column: 'CTAG/AG',
            value: context.get('CTAG'),
        },
        {
            label: 'Supplier Quality Assurance at Host Market',
            labelText: 'SQA at host market is to provide a due date for the completion of vendor audit related activities',
            column: 'SQA at host market',
            value: context.get('SQA')
        },
        {
            label: 'Quality in Factory',
            labelText: 'QA in factory is responsible to provide a due date for the completion of QA related activities & QIR creation',
            column: 'QA in Factory',
            value: context.get('QAInFactory')
        },
        {
            label: 'Procurement Specialist',
            labelText: 'Inclusion of PS is optional. PS can support in maintaining/updating the inputs provided in the workflow',
            column: 'Procurement Specialist',
            value: context.get('PS')
        },
    ];
    const handleTabChange = (event, newValue) => {
        event.preventDefault();
        logger.info("::: tab Index change ::", newValue);
        setState({ ...state, value: newValue });
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event) => {
        setState({ ...state, country: event.target.value });
    };

    const handleScrollUp = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    }

    const handleTargetBCPChange = (event) => {
        logger.info("::Input saving value::", event.target.value)
        setState(({ ...state, targetBCP: event.target.value }));
    };


    // Create the react equivalent for the drop down
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12} md={12} ref={messageRef}>
                    {state.showSuccessMessage && <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                        All Details updated successfully !!
                    </Alert>}
                </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'top' }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        <Snackbar open={openSnackBar} autoHideDuration={3000} onClose={handleCloseBar}
                            sx={{
                                marginRight: '80px',
                                height: '18%',
                            }}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right"
                            }}>
                            <Alert onClose={handleCloseBar} severity="warning" variant="filled">
                                No data to save!
                            </Alert>
                        </Snackbar>
                    </Grid>
                </Grid>
            </Box >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={state.value} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab sx={{ textTransform: "none" }} label="Vendor Details" {...a11yProps(0)} />
                    <Tab sx={{ textTransform: "none" }} label="Stakeholders" {...a11yProps(1)} />
                    <Tab sx={{ textTransform: "none" }} label="Other Data" {...a11yProps(2)} />
                </Tabs>
                <Dialog
                    open={open}
                    slots={{
                        transition: Transition,
                    }}
                    keepMounted
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Confirm changes?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Do you want to confirm, all selected BCP requests will get updated with latest information provided.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ textTransform: "none" }} onClick={handleClose}>Dismiss</Button>
                        <Button sx={{ textTransform: "none" }} onClick={handleDataSave}>Confirm</Button>
                    </DialogActions>
                </Dialog>
            </Box>
            <CustomTabPanel value={state.value} index={0}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        &nbsp;
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Alternate Vendor'}
                          <Tooltip title={
                                <React.Fragment>
                                    <em>{"The alternative vendor site number is a critical input for the BCP request workflow for the workflow closure. Without this input, the workflow could not detect if the QIR based on the alternative vendor site has been created."}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                         
                    </Grid>
                    <Grid item xs={5} sm={5} lg={5} md={5}>
                        <AlternativeVendorDropdown
                            context={context}
                            bcpRequest={state.bcpRequest}
                            onChange={(newVendor) => {
                                logger.info(" New Vendor for alternate vendor", newVendor.value)
                                setState({ ...state, alternateVendor: newVendor.value });
                                const vendorVal = newVendor?.value?.slice(0, newVendor.value.indexOf('-')) || null
                                checkAltVendor(vendorVal)
                            }}

                            initialValue={state.alternateVendor}
                            disabled={false}
                            setDisableVendor={setDisableVendor}
                            property={BCP.alternativeVendorCodeProp}
                            type={'AlternativeVendorDD'}
                            multiSelect={true}
                            selectedBCP={applicationContext.get("selectedBCPs")}
                        />
                    </Grid>
                    <Grid item xs={4} sm={4} lg={4} md={4}>
                        &nbsp;
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        &nbsp;
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'MV Linked'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Input main vendor number that is linked to the alternative vendor site."}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                        
                    </Grid>
                    <Grid item xs={5} sm={5} lg={5} md={5}>
                        <AlternativeVendorDropdown
                            context={context}
                            bcpRequest={state.bcpRequest}
                            onChange={(newVendor) => {
                                logger.info(" New VENDOR FOR mv lINKED VENDOR", newVendor.value)
                                const vendorVal = ["No vendor selected", null].includes(newVendor.value) ? null : newVendor.value.slice(0, newVendor.value.indexOf('-'));
                                checkAltVendor(vendorVal)
                                setState({ ...state, mvLinkedVendor: newVendor.value });
                            }}
                            initialValue={state.mvLinkedVendor || ''}
                            disabled={false}
                            setDisableVendor={setDisableVendor}
                            property={BCP.mainVendorLinkedAltVendorProp}
                            type={'MVLinkedDD'}
                            multiSelect={true}
                            selectedBCP={applicationContext.get("selectedBCPs")}
                        />
                    </Grid>
                    <Grid item xs={4} sm={4} lg={4} md={4}>
                        &nbsp;
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        &nbsp;
                    </Grid>

                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        <Divider></Divider>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        <Alert icon={<InfoIcon fontSize="inherit" />} severity='info' sx={{
                            width: 'auto',
                            display: 'flex',
                            color: 'black',
                            padding: '0.25rem 0.5rem'
                        }}>
                            <span>For new alternative vendor sites without a vendor number, please fill in all the below fields:</span>
                        </Alert>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        <Divider></Divider>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Vendor Name'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                        
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField size="small" label="" variant="outlined"
                            inputProps={{
                                style: {
                                    height: "1.25rem", width: "23.75rem",
                                },
                                form: {
                                    autoComplete: 'off',
                                },
                            }}
                            value={state.vendorName == null ? '' : state.vendorName}
                            autoComplete='false'
                            disabled={disableVendor}
                            onChange={(event) => {
                                setState({ ...state, vendorName: event.target.value });
                            }} />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Vendor Address'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                        
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField multiline
                            rows={2}
                            inputProps={{
                                style: {
                                    width: "23.75rem",
                                },
                                form: {
                                    autoComplete: 'off',
                                }
                            }}
                            disabled={disableVendor}
                            label="" variant="outlined"
                            value={state.vendorAddress == null ? '' : state.vendorAddress}
                            onChange={(event) => {
                                setState({ ...state, vendorAddress: event.target.value });
                            }} />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Vendor Country'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                        
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <div sx={{ height: "40px", width: "23.75rem" }}>
                            <FormControl >
                                <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={state.country || ""}
                                    onChange={handleChange}
                                    autoWidth
                                    displayEmpty
                                    disabled={disableVendor}
                                >
                                    {contriesList?.map((element, index) => {
                                        return (<MenuItem value={element} key={index}>{element}</MenuItem>)
                                    })}

                                </Select>
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3} >
                        {'Vendor City'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                        
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField size="small" inputProps={{
                            style: {
                                height: "1.25rem", width: "23.75rem",
                            },
                            form: {
                                autoComplete: 'off',
                            }
                        }} label="" variant="outlined"
                            disabled={disableVendor}
                            value={state.vendorCity == null ? '' : state.vendorCity}
                            onChange={(event) => {
                                setState({ ...state, vendorCity: event.target.value });
                            }}
                        />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Vendor Contact Number'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                        
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField size="small" inputProps={{
                            style: {
                                height: "1.25rem", width: "23.75rem",
                            },
                            form: {
                                autoComplete: 'off',
                            }
                        }} label="" variant="outlined"
                            disabled={disableVendor}
                            value={state.vendorContactNo == null ? '' : state.vendorContactNo}
                            onChange={(event) => {
                                setState({ ...state, vendorContactNo: event.target.value });
                            }} />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Vendor Email'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                        
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField size="small"
                            error={emailError}
                            helperText={emailError}
                            inputProps={{
                                style: {
                                    height: "1.25rem", width: "23.75rem",
                                }, form: {
                                    autoComplete: 'off',
                                }
                            }} label="" variant="outlined"
                            disabled={disableVendor}
                            value={state.vendorEmail == null ? '' : state.vendorEmail}
                            onChange={(event) => {
                                setState({ ...state, vendorEmail: event.target.value });
                                if (!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$/.test(event.target.value)) {
                                    setEmailError("Invalid email address");
                                } else {
                                    setEmailError(false);
                                }
                            }} />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={state.value} index={1}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12} md={12}>
                        <Alert icon={<InfoIcon fontSize="inherit" />} severity='info' sx={{
                            display: 'flex',
                            color: 'black',
                            width: '53.75rem',
                            padding: '0.5rem 0.5rem'
                        }}>
                            Attention: For updating multiple stakeholders information, it will only update stakeholders that have not yet accepted<br /> the BCP requests. For rejected BCP requests, no update will be performed.
                        </Alert>
                    </Grid>
                </Grid>
                {dropdownFields.map((element) => {
                    return (
                        <React.Fragment key={element.column}>
                            <Grid container spacing={1} sx={{ mt: 1, pb: 1 }}>
                                <Grid item xs={4} md={4} lg={4} sm={4} sx={{
                                    height: '40px !important',
                                    marginTop: '16px !important',
                                    maxHeight: '40px !important',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap',
                                    whiteSpace: 'nowrap',
                                }}>
                                <span style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                                    {element.label}
                                </span>

                                <Tooltip
                                    title={
                                        <React.Fragment>
                                            <em>{element.labelText}</em>
                                        </React.Fragment>
                                    }
                                >
                                    {getIcon("Info", true, {
                                        style: {
                                            minWidth: "25px",
                                            flexShrink: 0,
                                        },
                                    })}
                                </Tooltip>                                   
                                </Grid>
                                <Grid item xs={8} md={8} lg={8} sm={8} sx={{
                                    position: "relative",
                                    paddingLeft: "20px !important",
                                    left: "20px",
                                    '& .MuiAutocomplete-root .MuiInput-underline.MuiInputBase-root': {
                                        width: '90% !important'
                                    },
                                    '& .MuiAutocomplete-popper': {
                                        width: '90% !important',
                                        position: 'absolute !important',
                                        transform: 'none !important'
                                    },
                                    '& [o_id]': {
                                        height: '40px !important',
                                        maxHeight: '40px !important'
                                    }
                                }}>
                                    <GetReactElement
                                        columnName={element.column}
                                        data={element?.value?.displayName
                                            ?.concat(';')
                                            ?.concat(element?.value?.mail) || ""}
                                        bcpRequest={state.bcpRequest}
                                        isUserDDDisabled={false}
                                        state={state}
                                        setState={setState}
                                        context={context}
                                    />
                                </Grid>
                                {element.column === QA_ROLES.SQA && (
                                    <a
                                        href={sqaLink}
                                        target='_blank'
                                        className={sqaLink ? 'sqaLink' : 'sqaLinkUndefined'}
                                        style={{ padding: '0.5rem', marginTop: '1px', width: '100%', fontSize: "0.875rem" }}>
                                        Refer the link to update SQA
                                    </a>
                                )}
                            </Grid>
                        </React.Fragment>)
                })}
            </CustomTabPanel>
            <CustomTabPanel value={state.value} index={2}>
                {<Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Priority'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>The priority indicates the urgency of the BCP request. Choose “high” if BCP request related to an ongoing supply chain crisis, “low” if BCP request related to a Sourcing Flexibility activity</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                          
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <HighLowDropdown state={state} setState={setState} label={"Priority"}></HighLowDropdown>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        &nbsp;
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Target BCP'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Target BCP to be developed either an alternative vendor site, alternative vendor or totally new vendor"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                           
                    </Grid>
                    <Grid item xs={9} sm={9} lg={9} md={9}>
                        <FormControl>
                            <Select
                                value={state.targetBCP}
                                onChange={handleTargetBCPChange}
                                displayEmpty
                                disabled={false}
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                <MenuItem value={"alternateSiteNewVendor"}>Alternate site with new Vendor</MenuItem>
                                <MenuItem value={"alternateSiteSameVendor"}>Alternate site with same Vendor</MenuItem>
                                <MenuItem value={"alternativeSiteApprovedPlant"}>Alternative site with new Vendor already approved in other plants</MenuItem>

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Oscar Id'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide Oscar ID number if any"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                          
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField size="small" label="" variant="outlined"
                            inputProps={{
                                style: {
                                    height: "1.25rem", width: "17.5rem",
                                },
                                form: {
                                    autoComplete: 'off',
                                },
                            }}
                            value={state.oscarId == null ? '' : state.oscarId}
                            autoComplete='false'
                            onChange={(event) => {
                                setState({ ...state, oscarId: event.target.value });
                            }}
                            onBlur={(event) => {
                                setState({ ...state, oscarId: event.target.value });
                            }}
                        /></Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        &nbsp;
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Input Savings indicator'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide whether cost saving applicable for BCP request"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                          
                    </Grid>

                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <YesNoDropdown state={state} setState={setState} label={"InputSavings"}></YesNoDropdown>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Input Savings est. [CHF]'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide cost saving input if BCP request has any cost savings"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                          
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField
                            label="Numeric value"
                            autoComplete='off'
                            value={(state.savingsIndicator?.length === 0 || state.savingsIndicator === 'no') ? "" : state.inputSavingsValue}
                            onChange={handleNumberChange}
                            name="numberformat"
                            disabled={state.savingsIndicator?.length === 0 || state.savingsIndicator === 'no'}
                            id="formatted-numberformat-input"
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                                style: {
                                    width: "23.75rem",
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Maguire Applicable?'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide input if BCP request is related to Maguire initiative"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                            
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <YesNoDropdown state={state} setState={setState} label={"Maguire"}></YesNoDropdown>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Any GHG reduction?'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide GHG Reduction input if BCP request has any GHG reduction"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                          
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <YesNoDropdown state={state} setState={setState} label={"GHD"}></YesNoDropdown>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>
                        {'Remarks'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide GHG Reduction input if BCP request has any GHG reduction"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                          
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6} md={6}>
                        <TextField size="small" label="" variant="outlined"
                            multiline
                            rows={2}
                            inputProps={{
                                style: {
                                    width: "23.75rem",
                                },
                                form: {
                                    autoComplete: 'off',
                                },
                            }}
                            value={state.remarks == null ? '' : state.remarks}
                            autoComplete='false'
                            onChange={(event) => {
                                setState({ ...state, remarks: event.target.value });
                            }}
                            onBlur={(event) => {
                                setState({ ...state, remarks: event.target.value });
                            }}
                        />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                    <Grid item xs={12} sm={12} lg={12} md={12}>&nbsp;</Grid>
                </Grid>}
            </CustomTabPanel>

            <div className={'center_button_mass-update'}>
                <Button variant="contained"
                    onClick={() => {
                        if (getButtonStatus()) {
                            setOpenSnackBar(true)
                        } else {
                            setOpen(true)
                        }
                    }}
                    size="small"
                    className={'update-QA-apply-changes-button'}
                    startIcon={getIcon('Save')}
                    disabled={false}>
                    Update
                </Button>
            </div>
        </>);
}
